import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.scss'],
})
export class TermsDialogComponent implements OnInit {
  htmlData;
  showButton = false;
  terms;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthenticationService
  ) {
    this.htmlData = data?.termData?.docTmplt;
    this.showButton = data?.showButton;
  }

  ngOnInit(): void {
    this.authService.getTermsOfUsage().subscribe((res) => {
      this.terms = res?.docTmplt;
    });
  }
}
